import { emailService } from './emailService';
import { UserNotificationBatch } from '../types';

export const notificationSenderService = {
  /**
   * Processes a list of user notification batches and sends email notifications.
   * Returns stats of successful and failed email sends.
   */
  async sendAuditChangeEmails(batches: UserNotificationBatch[]): Promise<{
    totalBatches: number;
    sentCount: number;
    failedCount: number;
  }> {
    let sentCount = 0;
    let failedCount = 0;

    for (const batch of batches) {
      if (!batch.userEmail) {
        console.warn('[notificationSenderService] Skipping batch: user email is missing.');
        failedCount++;
        continue;
      }
      
      if (batch.affectedAudits.length === 0) {
        console.warn(`[notificationSenderService] Skipping batch for ${batch.userEmail}: no affected audits.`);
        continue;
      }

      try {
        const success = await emailService.sendStaleAuditNotification(batch);
        if (success) {
          sentCount++;
        } else {
          failedCount++;
        }
      } catch (error) {
        console.error(`[notificationSenderService] Failed sending email to ${batch.userEmail}:`, error);
        failedCount++;
      }
    }

    return {
      totalBatches: batches.length,
      sentCount,
      failedCount,
    };
  },
};
